<div class="container-fluid glb-popup">
	<h2>{{formTitle}}</h2>
	<p-toast [style]="{marginTop: '80px'}"></p-toast>

	<button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
		<i class="pi pi-times" aria-hidden="true"></i>
	</button>
	<hr>
	<div [formGroup]="AdvSearchForm" class="forms w-100 d-block">
		<div class="row m-0 expense-advance-search-form">
			<div class="col-lg-12">
				<span class="p-float-label my-2 me-2 d-block">
					<!-- <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'30vh'" 
						[options]="properties" formControlName="shortTermRentalIds" id="shortTermRentalIds" 
						defaultLabel="Select Property" dataKey="shortTermRentalId" optionLabel="propertyCode" 
						display="chip" appendTo="body">
					</p-multiSelect> -->

				<p-dropdown appendTo="body" dropdownIcon="fa fa-caret-down" [options]="properties"
					formControlName="shortTermRentalId" optionLabel="propertyCode"
					optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode"
					[showClear]="false" placeholder="Select Property">
				</p-dropdown>
					<label for="shortTermRentalIds">Property</label>
				</span>
			</div>

			<div class="col-lg-12">
				<span class="p-float-label my-2 me-2">
					<input formControlName="taskName" id="taskName" type="text" pInputText>
					<label for="taskName">Task Name</label>
				</span>
			</div>

			<div class="col-lg-12">
				<span class="p-float-label my-2 me-2">
					<p-calendar appendTo="body" formControlName="expenseDate" inputId="expenseDate">
					</p-calendar>
					<label for="expenseDate">Expense Date</label>
				</span>
			</div>

			<div class="col-lg-12">
				<span class="p-float-label my-2 me-2">
					<input formControlName="amount" id="amount" type="text" pInputText>
					<label for="amount">Amount</label>
				</span>
			</div>
		</div>
	</div>
	<hr>
	<div class="row m-0">
		<div class="col-lg-12">
			<div class="btn-group">
				<div class="button-group">
					<button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
					<button pButton class="btn-addt p-button" (click)="formSubmit()">Search</button>
				</div>
			</div>
		</div>
	</div>
</div>
